import { ApiUrl, Call, ParseGeneralResponse } from '@api/ApiUtils';

export interface StreamTokenResponse {
  streamtoken: string;
}

export const fetchStreamToken = () => (
  Call(
    'get',
    ApiUrl('/stream/token'),
    {},
    ParseGeneralResponse,
    { responseDataKeys: { streamtoken: 'streamtoken' } }
  ) as Promise<StreamTokenResponse>
);

export interface FeedsTokenResponse {
  errors?: string[];
  // Seconds until the token stops working, counted from when the response arrives; null when Feeds is disabled
  expiresIn: number | null;
  // GetStream Feeds (notification bell) token; null when Feeds is disabled
  token: string | null;
}

export const fetchFeedsToken = () => (
  Call(
    'get',
    ApiUrl('/stream/feeds_token'),
    {},
    ParseGeneralResponse,
    { responseDataKeys: { expiresIn: 'expires_in', token: 'token' } }
  ) as Promise<FeedsTokenResponse>
);
